<template>
  <div>
    <div class="foot-tab" :class="{'!rounded-b-none' : noCorners}">
      <div class="foot-tab-head">
        <div class="foot-tab-row-label">
					<span class="cursor-pointer underline zt-hover whitespace-nowrap min-w-[18px] pl-[10px]"
                @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
          <span class="cursor-pointer underline zt-hover truncate"
                :class="{ '!no-underline' : sortColumn === 'name' }"
                @click="sortTable('name', $event)">{{getTitleString(phaseString)}}</span>
        </div>
        <div class="flex">
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'matches' }"
               @click="sortTable('matches', $event)">
            <div>M</div>
          </div>
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'sr' }"
               @click="sortTable('sr', $event)">
            <div>ŚR</div>
          </div>
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'skut' }"
               @click="sortTable('skut', $event)">
            <div>Skut.</div>
          </div>
        </div>
      </div>
      <div class="foot-tab-row" :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.id), '!border-b-0 !rounded-b-zt': index === teams.length - 1 }"
           v-for="(team, index) in teams" :key="team.id">
        <div class="foot-tab-row-label" :class="{ '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.id) }">
          <p class="flex items-center">
            <span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  teams.length - index : index + 1}}.</span>
            <a v-if="!selectedTeamsIds.includes(+team.id)"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.team_query_name}/` : null"
               class="no-default-style" :class="{ 'zt-hover': team.clickable }">
              <span class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
            </a>
            <span v-else class="flex items-center mr-2 aspect-square h-5">
              <TeamImg :team="team"/>
            </span>
            <a v-if="!selectedTeamsIds.includes(+team.id)"
               class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.team_query_name}/` : null">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </a>
            <span v-else class="text-ellipsis line-clamp-1 break-all">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </span>
          </p>
        </div>
        <Transition appear name="fade" mode="out-in">
          <div :key="filterKey" class="flex">
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' }">
              <div>{{ team.datailed_stats.match_count }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'sr' }">
              <div>{{ (team.datailed_stats.totalpasses / team.datailed_stats.match_count).toFixed(0) }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'skut' }">
              <div>{{ ((team.datailed_stats.passaccurate / team.datailed_stats.totalpasses) * 100).toFixed(0) }}%</div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>

import football_mixin from "../../mixins/football_mixin";
import TeamImg from "../football_stats/blocks/TeamImg.vue";
import {useStatsStore} from "../../stores/StatsStore";

export default {
  name: 'PassesTable',
  components: {TeamImg},
  inject: ['WP'],
  mixins: [football_mixin],
  props: {
    noCorners: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: ''
    },
    teams: Array,
    filters: Array,
    details: Object,
    selectedTeamsIds: {
      type: Array,
      default: []
    },
    events: Array,
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    },
    leagueId: {
      type: Number,
      default: -1
    },
    timeFrame: {
      type: String,
      default: 'all'
    },
  },
  data() {
    return {
      previousSortColumn: null,
      displayedTable: 'all',
      sortColumn: 'sr',
      sortAscending: 0,
      isLpSet: false,
      currentSubTab: this.filters[1] ?? 'all',
      teamsSorted: []
    }
  },
  setup() {
    const statsStore = useStatsStore();
    return { statsStore };
  },
  async mounted() {
    await this.statsStore.getDetailedStatisticsForLeague(this.leagueId);
    await this.statsStore.getDetailedStatisticsForLeague(this.leagueId, 10);
    this.teamsSorted = this.statsStore.detailedStats[this.leagueId];
    this.teamsSorted = this.teamsSorted.sort(this.sortTeams);
  },
  computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
    teams() {
      if (this.teamsSorted && this.teamsSorted.length > 0) {
        return this.teamsSorted.slice().sort(this.sortTeams);
      }	else {
        return this.teamsSorted;
      }
    },
  },
  watch: {
    filters(newVal) {
      setTimeout(() => {
        this.currentSubTab = newVal[1];
        this.teams.sort(this.sortTeams).forEach((team, i) => {team.currentTablePosition = i+1;});
      }, 250);
    }
  },
  methods: {
    sortTeams(a, b) {
      let diff = 0;
      if (this.sortColumn === 'name') {
        if (this.sortAscending) {
          diff = a.name.localeCompare(b.name);
        } else {
          diff = b.name.localeCompare(a.name);
        }
        return diff;
      }

      switch (this.sortColumn) {
        case 'matches':
          if (this.sortAscending) {
            diff = a.datailed_stats.match_count - b.datailed_stats.match_count;
          } else {
            diff = b.datailed_stats.match_count - a.datailed_stats.match_count;
          }
          break;
        case 'sr':
          if (this.sortAscending) {
            diff = (a.datailed_stats.totalpasses / a.datailed_stats.match_count) - (b.datailed_stats.totalpasses / b.datailed_stats.match_count);
          } else {
            diff = (b.datailed_stats.totalpasses / b.datailed_stats.match_count) - (a.datailed_stats.totalpasses / a.datailed_stats.match_count);
          }
          break;
        case 'skut':
          if (this.sortAscending) {
            diff = (a.datailed_stats.passaccurate / a.datailed_stats.totalpasses) - (b.datailed_stats.passaccurate/ b.datailed_stats.totalpasses);
          } else {
            diff = (b.datailed_stats.passaccurate / b.datailed_stats.totalpasses) - (a.datailed_stats.passaccurate / a.datailed_stats.totalpasses);
          }
          break;
      }
      return diff;

    }
  }
}

</script>

<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>